import { AxiosResponse } from 'axios'
import { snakeCase } from 'lodash/fp'

import {
  JSONApiObjectWithRelationships,
  JSONApiObjectWithRelationshipsMap,
  NormalizedJSONApiResponse,
  ToOneRelationship,
} from 'packages/utils/store'

/**********************************************************
 * REDUX TYPES
 *********************************************************/
export enum CoveragePartnerActionTypes {
  CREATE_COVERAGE_PARTNER = 'COVERAGE_PARTNERS/API/CREATE_COVERAGE_PARTNER',
  CREATE_COVERAGE_PARTNER_FAILURE = 'COVERAGE_PARTNERS/CREATE_COVERAGE_PARTNER_FAILURE',
  CREATE_COVERAGE_PARTNER_SUCCESS = 'COVERAGE_PARTNERS/CREATE_COVERAGE_PARTNER_SUCCESS',

  FETCH_COVERAGE_PARTNERS = 'COVERAGE_PARTNERS/API/FETCH_COVERAGE_PARTNERS',
  FETCH_COVERAGE_PARTNERS_FAILURE = 'COVERAGE_PARTNERS/FETCH_COVERAGE_PARTNERS_FAILURE',
  FETCH_COVERAGE_PARTNERS_SUCCESS = 'COVERAGE_PARTNERS/FETCH_COVERAGE_PARTNERS_SUCCESS',
}

export type CoveragePartnerState = {
  standardCoveragePartner: RawCoveragePartner
}

/**********************************************************
 * SERVICE TYPES
 *********************************************************/
export type CoveragePartnerResponse = {
  coveragePartner: JSONApiCoveragePartnerMap
}

export type NormalizedCoveragePartnerApiResponse =
  NormalizedJSONApiResponse<CoveragePartnerResponse>

export type CoveragePartnerServiceResponse =
  Promise<NormalizedCoveragePartnerApiResponse>

export type CoveragePartnerApiResponse =
  AxiosResponse<NormalizedCoveragePartnerApiResponse>

export type CoveragePartnerPostData = {
  coveredUserId: string
  coveringUserId: string
}

/**********************************************************
 * COVERAGE PARTNER
 *********************************************************/
export type CoveragePartner = {
  id: string
} & CoveragePartnerAttributes

export type CoveragePartnerAttributes = {
  startDate: string
}

export const CoveragePartnerAttributeNames = ['startDate']

export const CoveragePartnerApiFields: string[] =
  CoveragePartnerAttributeNames.map(snakeCase)

export type CoveragePartnerRelationships = {
  user: ToOneRelationship
}

export type RawCoveragePartner = JSONApiObjectWithRelationships<
  CoveragePartnerAttributes,
  CoveragePartnerRelationships
>

export type JSONApiCoveragePartnerMap = JSONApiObjectWithRelationshipsMap<
  CoveragePartnerAttributes,
  CoveragePartnerRelationships
>
